<h1>Usage</h1>
<p>You can find a spending of your credits for prompts execution on this page.</p>
<span *ngIf="usage$ | async as usage; else loading"
  >Current usage: {{ (usage.currentUsage | roundDigits) || 0 }} credits</span
>
<ng-template #loading>
  <mat-spinner></mat-spinner>
</ng-template>
